export const aceStyles = {
	header: {
		backgroundColor: '#062f87',
	},
	sidebar: {
		backgroundColor: '#495057',
		color: 'white',
	},
	button: {
		backgroundColor: '#2fc936',
		border: '1px solid #239729',
		color: '#fff',
		fontWeight: 600,
		':hover': {
			backgroundColor: '#239729',
		},
	},
	text: {
		color: '#495057',
		buttonLoadingColor: '#FFFFFF',
	},
	title: {
		color: '#fff',
	},
	table: {
		headerBackgroundColor: '#062f87',
		headerTextColor: '#ffffff',
	},
	platformName: {
		name: 'Ace Parking Platform',
	},
	logo: {
		small: {
			src: '/ace/ace-logo.svg',
			height: 40,
			width: 40,
		},
		large: {
			src: '/ace/ace-logo.svg',
			height: 60,
			width: 60,
		},
	},
	favicon: {
		src: '/ace/ace-logo.svg',
	},
	socials: {},
	siteUrl: 'https://parkwithace.com/',
	orgName: 'Ace',
};
